// PROD
const PROD_LASER_HAIR_REMOVAL_ONLINE_CONSULT_ID = '161d1d39-6fb6-45b1-a248-ad58115743f4';
// STAGE
const STAGE_LASER_HAIR_REMOVAL_ONLINE_CONSULT_ID = '144f3f68-7504-4459-b4cf-30eafadf9331';

export const getLaserHairRemovalOnlineConsultId = (environment: string) => {
	return environment === 'local' || environment === 'stage'
		? STAGE_LASER_HAIR_REMOVAL_ONLINE_CONSULT_ID
		: PROD_LASER_HAIR_REMOVAL_ONLINE_CONSULT_ID;
};
